'use client';

import type { AccountTab } from '@/components/Account';

const OPEN_ACCOUNT_DIALOG_EVENT = 'app:open-account-dialog';
const OPEN_ALERT_DIALOG_EVENT = 'app:open-alert-dialog';

interface OpenAccountDialogDetail {
  tab: AccountTab;
}

interface OpenAlertDialogDetail {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  size?: 'sm' | 'default';
  contentClassName?: string;
  onConfirm?: () => void;
}

export const appDialogBus = {
  onOpenAccountDialog(callback: EventListenerOrEventListenerObject) {
    window.addEventListener(OPEN_ACCOUNT_DIALOG_EVENT, callback);
  },
  offOpenAccountDialog(callback: EventListenerOrEventListenerObject) {
    window.removeEventListener(OPEN_ACCOUNT_DIALOG_EVENT, callback);
  },
  fireOpenAccountDialog(tab: AccountTab) {
    window.dispatchEvent(new CustomEvent<OpenAccountDialogDetail>(OPEN_ACCOUNT_DIALOG_EVENT, {
      detail: { tab },
    }));
  },
  onOpenAlertDialog(callback: EventListenerOrEventListenerObject) {
    window.addEventListener(OPEN_ALERT_DIALOG_EVENT, callback);
  },
  offOpenAlertDialog(callback: EventListenerOrEventListenerObject) {
    window.removeEventListener(OPEN_ALERT_DIALOG_EVENT, callback);
  },
  fireOpenAlertDialog(detail: OpenAlertDialogDetail) {
    window.dispatchEvent(new CustomEvent<OpenAlertDialogDetail>(OPEN_ALERT_DIALOG_EVENT, {
      detail,
    }));
  },
  fireOpenInsufficientPointsDialog(requiredPoints: number) {
    appDialogBus.fireOpenAlertDialog({
      title: 'Insufficient points',
      description: `This action requires ${requiredPoints} points. Please recharge and try again.`,
      cancelLabel: 'Cancel',
      confirmLabel: 'Recharge',
      size: 'default',
      contentClassName: 'sm:max-w-xl',
      onConfirm: () => {
        appDialogBus.fireOpenAccountDialog('recharge');
      },
    });
  },
};

export type { OpenAccountDialogDetail, OpenAlertDialogDetail };
